import React from "react";
import Button from "@/Components/Button";
import { useRouter } from "next/navigation";

interface ContactButtonProps {
    onContactClick: () => void;
}

const ContactButton: React.FC<ContactButtonProps> = ({ onContactClick }) => {
    const router = useRouter();

    return (
        <div className="lg:block hidden">
            <Button
                variant="small"
                className="my-0 xl:text-subtitle-3 whitespace-nowrap lg:text-subtitle-4 xl:max-h-[auto] lg:max-h-[42px] xl:max-w-[auto] lg:max-w-[156px]"
                label="Contact us"
                onClick={() => {
                    router.push("/request-proposal");
                    onContactClick();
                }}
            />
        </div>
    );
};

export default ContactButton;
